import { useEffect } from 'react';
import { Card, Form, Grid, Header, Radio, Segment } from 'semantic-ui-react';
import { TextField } from '../../../common/FormFields';
import { connect } from 'react-redux';
import * as R from 'ramda';
import * as actions from '../../../../redux/actions';
import * as selectors from '../../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import FirmDropDown from '../../FirmDropDown';
import SitesDropDown from '../../SitesDropDown';

const AdSlotPageInformation = ({ formik, getFirmById, firm }) => {
  useEffect(() => {
    if (formik.values.firmIds.length > 0) {
      const firmId = R.head(formik.values.firmIds);
      getFirmById(firmId);
    }
  }, [formik.values.firmIds, getFirmById]);

  useEffect(() => {
    if (firm && firm.id && formik.values.firmIds.length > 0) {
      const fields = [
        'backgroundTextColor',
        'backgroundColor',
        'buttonColor',
        'buttonTextColor',
        'headerThinIndex',
        'buttonText',
        'presentedByColor',
        'googleAnalyticsTag',
        'siteIds',
      ];
      const toForm = field => formik.setFieldValue(field, firm[field]);
      const ifNotNull = field => firm[field] && !formik.values[field];
      fields.filter(ifNotNull).map(toForm);
      if (!formik.values.url) {
        formik.setFieldValue('url', firm?.website);
      }
    }
  }, [firm]);

  const getPage = () => (
    <>
      <Segment attached className="adslot-page-information">
        <Form size="small" widths="equal" onSubmit={formik.handleSubmit}>
          <Grid style={{ marginBottom: 0 }}>
            <Grid.Row>
              <Grid.Column width="8">
                <FirmDropDown
                  name="firmIds"
                  label="Firms"
                  multiple={true}
                  formik={formik}
                  value={formik.values.firmIds || []}
                  onChange={formik.handleChange}
                  error={formik.touched.firmIds && Boolean(formik.errors.firmIds)}
                  errorMessage={formik.errors.firmIds}
                />

                <TextField
                  name="analyticsCategory"
                  label="Google analytics category"
                  disabled={true}
                  formik={formik}
                  value={formik.values.googleAnalyticsTag}
                  onChange={formik.handleChange}
                  error={formik.touched.googleAnalyticsTag && Boolean(formik.errors.googleAnalyticsTag)}
                  errorMessage={formik.errors.googleAnalyticsTag}
                />

                <TextField
                  name="title1"
                  label="Title"
                  formik={formik}
                  value={formik.values.title1}
                  onChange={formik.handleChange}
                  error={formik.touched.title1 && Boolean(formik.errors.title1)}
                  errorMessage={formik.errors.title1}
                />

                <TextField
                  label="Thin Word Position"
                  name="headerThinIndex"
                  type="number"
                  min="0"
                  step="1"
                  formik={formik}
                  value={formik.values.headerThinIndex || ''}
                  onChange={formik.handleChange}
                  error={formik.touched.headerThinIndex && Boolean(formik.errors.headerThinIndex)}
                  errorMessage={formik.errors.headerThinIndex}
                />

                <Card fluid>
                  <Card.Content>
                    <Header content="Schedule" sub />
                    <br />

                    <Form.Field className="gm-datepicker">
                      <SemanticDatepicker
                        id="startDate"
                        name="startDate"
                        label="Start date"
                        formik={formik}
                        value={formik.values.startDate || new Date()}
                        onChange={(e, d) => formik.setFieldValue('startDate', d.value)}
                        error={formik.touched.startDate && Boolean(formik.errors.startDate)}
                        errorMessage={formik.errors.startDate}
                      />
                    </Form.Field>
                    <Form.Field className="gm-datepicker">
                      <SemanticDatepicker
                        id="endDate"
                        name="endDate"
                        label="End date"
                        formik={formik}
                        value={formik.values.endDate || new Date()}
                        onChange={(e, d) => formik.setFieldValue('endDate', d.value)}
                        error={formik.touched.endDate && Boolean(formik.errors.endDate)}
                        errorMessage={formik.errors.endDate}
                      />
                    </Form.Field>
                  </Card.Content>
                </Card>

                <br />
                <SitesDropDown
                  name="siteIds"
                  label="Sites"
                  multiple={true}
                  formik={formik}
                  value={formik.values.siteIds}
                  onChange={formik.handleChange}
                  error={formik.touched.siteIds && Boolean(formik.errors.siteIds)}
                  errorMessage={formik.errors.siteIds}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>

          <strong>Display Type</strong>
          <br />
          <Form.Group>
            <Form.Field width="2">
              <Radio
                label="Popup"
                name="radioGroup"
                value="popup"
                checked={formik.values.displayEffect === 'popup'}
                onChange={() => formik.setFieldValue('displayEffect', 'popup')}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Rollover"
                name="radioGroup"
                value="rollover"
                checked={formik.values.displayEffect === 'rollover'}
                onChange={() => formik.setFieldValue('displayEffect', 'rollover')}
              />
            </Form.Field>
          </Form.Group>
        </Form>
      </Segment>
    </>
  );

  return <>{formik && getPage()}</>;
};

const mapStateToProps = state => ({
  firm: selectors.firms.current(state),
  reps: selectors.getRepOptionsForFirm(state),
  currentAdSlot: selectors.getCurrentAdSlot(state),
});

const mapDispatchToProps = dispatch => ({
  addListing: bindActionCreators(actions.listing.addListing, dispatch),
  getAdSlotById: bindActionCreators(actions.adSlot.getAdSlotById, dispatch),
  createAdSlot: bindActionCreators(actions.adSlot.addAdSlot, dispatch),
  getFirmById: bindActionCreators(actions.firm.getFirmById, dispatch),
  getItemsForFirms: bindActionCreators(actions.adSlot.getItemsForFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdSlotPageInformation));
